export const WELCOME_BACK_DISMISS_UNTIL_KEY = 'cityscope_welcome_back_account_prompt_dismissed_until_v1';
export const WELCOME_BACK_NEVER_SHOW_KEY = 'cityscope_welcome_back_account_prompt_never_v1';
export const WELCOME_BACK_SUPPRESSION_META_KEY = 'cityscope_welcome_back_account_prompt_suppression_v1';
export const WELCOME_BACK_SUPPRESSION_COOKIE = 'cs_welcome_back_account_prompt_never';

const TWO_YEARS_SECONDS = 60 * 60 * 24 * 365 * 2;

function hasSuppressionCookie(): boolean {
  if (typeof document === 'undefined') return false;
  try {
    return document.cookie
      .split(';')
      .some((part) => part.trim().startsWith(`${WELCOME_BACK_SUPPRESSION_COOKIE}=1`));
  } catch {
    return false;
  }
}

export function hasWelcomeBackPromptSuppression(): boolean {
  if (typeof window === 'undefined') return false;

  try {
    if (
      window.localStorage.getItem(WELCOME_BACK_NEVER_SHOW_KEY) === '1' ||
      Boolean(window.localStorage.getItem(WELCOME_BACK_SUPPRESSION_META_KEY))
    ) {
      return true;
    }
  } catch {
    // Fall back to the first-party cookie below.
  }

  return hasSuppressionCookie();
}

export function suppressWelcomeBackPrompt(reason: string): void {
  if (typeof window === 'undefined') return;

  const suppressedAt = Date.now();

  try {
    window.localStorage.setItem(WELCOME_BACK_NEVER_SHOW_KEY, '1');
    window.localStorage.setItem(
      WELCOME_BACK_SUPPRESSION_META_KEY,
      JSON.stringify({ reason, suppressedAt }),
    );
    window.localStorage.removeItem(WELCOME_BACK_DISMISS_UNTIL_KEY);
  } catch {
    // The cookie path below still covers browsers where localStorage is unavailable.
  }

  if (typeof document !== 'undefined') {
    try {
      document.cookie = `${WELCOME_BACK_SUPPRESSION_COOKIE}=1; Max-Age=${TWO_YEARS_SECONDS}; Path=/; SameSite=Lax`;
    } catch {
      // Suppression is best-effort if all client storage is blocked.
    }
  }
}
